/*************************************************************************
* Copyright (c) 2025 Omnineura AI Technologies Pvt Limited.
* All rights reserved.
* This code is licensed under the 'Omnineura AI License' found in the LICENSE file.
* Unauthorized copying, sharing, or use of this code is prohibited.
* The intellectual and technical concepts are proprietary to Omnineura AI Technologies Pvt Limited.
* Author: surya@Omnineura.ai
* Date: 11-09-2025
*************************************************************************/




import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import ProtectedRoute from "./ProtectedRoute";
import Loader from "./loaders/Loader";

const LandingPage = lazy(() => import("./pages/LandingPage"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const HomePage = lazy(() => import("./pages/HomePage"));
const ConfigPage = lazy(() => import("./pages/Config"));
const ChatPage = lazy(() => import("./pages/ChatPage"));
const AnalyticsPage = lazy(() => import("./pages/AnalyticsPage"));
const KnowledgeBasePage = lazy(() => import("./pages/KnowledgeBasePage"));
const ApiKeyPage = lazy(() => import("./pages/ApiKeyPage"));
const CreditUsagePage = lazy(() => import("./pages/CreditUsagePage"));
const PaymentInterfacePage = lazy(() => import("./pages/PaymentInterfacePage"));

function App() {
  const loading = false;

  if (loading) {
    return <Loader />;
  }

  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            {/*  Dashboard common */}
            <Route element={<Dashboard />}>
              <Route path="/home" element={<HomePage />} />
              <Route path="/config" element={<ConfigPage />} />
              <Route path="/document" element={<KnowledgeBasePage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/chatSelection" element={<ChatPage />} />
              <Route path="/apiKey" element={<ApiKeyPage />} />
              <Route path="/creditUsage" element={<CreditUsagePage />} />
              <Route path="/payment" element={<PaymentInterfacePage />} />
            </Route>
          </Route>

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
